import React, { useState } from 'react';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';
import SingleBottomNav from 'components/base/single-bottom-nav';
import SelectionType from 'components/selection-type';

type formData = {
  name: string;
  summary: string;
  description: string;
  images: string[];
  icon: string;
  selection_no: string;
  min_selection_no: string;
  position: 0;
  slug: string;
  meal_category_selection_type_id: string;
};

const NewBaseAddonCategory = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    position: 0
  } as formData);

  const onConfirm = async () => {
    setLoading(true);
    try {
      const payload = formData;
      const res = await apiService.post('base-addon-category', {
        data: payload,
        isInternal: true
      });
      if (res.data) {
        setFormData({ position: 0 } as formData);

        toast(<ToastMessage type='success' message={'Base addon category created successfully'} />);
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    }
    setLoading(false);
  };
  const validateSlug = (val: string) => {
    return /^[A-Z_]+$/.test(val) || val.length === 0;
  };

  return (
    <div>
      <PageHeaderText
        title='Create New Base Add-on Category'
        description='Ensure you provide correct details'
      />
      <div className='w-[48em]'>
        <Input
          small
          label='Addon category name'
          type='text'
          placeholder='Addon category name'
          className='mt-8 text-sm'
          inputClass='px-[20px] py-[14px]'
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <Input
          small
          label='Addon category slug'
          type='text'
          placeholder='Addon category slug'
          className='mt-8 text-sm'
          inputClass='px-[20px] py-[14px]'
          value={formData.slug || ''}
          onChange={(e) => {
            if (validateSlug(e.target.value)) {
              setFormData({ ...formData, slug: e.target.value });
            }
          }}
        />
        <Input
          small
          label='Addon category description'
          type='text'
          placeholder='Addon category description'
          className='my-6 text-sm'
          inputClass='px-[20px] py-[14px]'
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />

        <SelectionType
          selectionType={formData.meal_category_selection_type_id}
          setSelectionType={(e) => setFormData({ ...formData, meal_category_selection_type_id: e })}
        />

        <Input
          small
          label='Min Selection'
          type='tel'
          placeholder='Select number'
          className='mt-12 text-sm'
          inputClass='px-[20px] py-[14px]'
          value={formData.min_selection_no}
          onChange={(e) => setFormData({ ...formData, min_selection_no: e.target.value })}
        />
        <Input
          small
          label='Max selection'
          type='tel'
          placeholder='Enter number'
          className='mt-5 text-sm'
          inputClass='px-[20px] py-[14px]'
          value={formData.selection_no}
          onChange={(e) => setFormData({ ...formData, selection_no: e.target.value })}
        />
        <SingleBottomNav
          onConfirm={onConfirm}
          btnDisabled={
            !formData?.name || !formData?.slug || !formData?.meal_category_selection_type_id
          }
          loading={loading}
        />
      </div>
    </div>
  );
};

export default NewBaseAddonCategory;
